import { Arr } from '@deqo/foundation';
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { ObjectManager } from '../../../concepts/objects';
import { resolveSubject, resolveSubjects } from '../../canvas/commands/CommandUtil';
import { beginMutating } from '../../canvas/commands/ManipulationCommands';
import { organizeSquash } from '../../canvas/commands/OrganizeCommands';
import { Phys } from '../../canvas/entities/Phys';
import { tagsAdd } from '../annotations/TaggingCommands';
import { Sticky } from '../paper/Sticky';
import { ContrastColorList } from '../tabularImport/strategies/ContrastColorList';
import { Topic } from './Topic';
import { TopicAssocation } from './TopicAssociations';
import { TopicIndex } from './TopicIndex';

export const topicTidy = defineCommand(
    'topicTidy',
    'Topic: Tidy',
    (cc, [targetId]: [string?]) => {

        const index = cc.resolve(TopicIndex);
        const topic = resolveSubject(cc, targetId)?.as(Topic);

        if (!topic) return;
        const items = index.lookup(topic.id);
        if (items.size === 0) return;

        const ids = [topic.id, ...Array.from(items).map(i => i.id)];
        cc.dispatch(organizeSquash, [ids]);
    }
);

export const topicApplyColor = defineCommand(
    'topicApplyColor',
    'Topic: Apply Color Tidy',
    (cc, [targetId]: [string?]) => {

        const objects = cc.resolve(ObjectManager);
        const index = cc.resolve(TopicIndex);
        const topic = resolveSubject(cc, targetId)?.as(Topic);

        if (!topic) return;
        const items = index.lookup(topic.id);
        if (items.size === 0) return;

        objects.update(() => {
            for (const tm of items) {
                tm?.as(Sticky, s => s.background = topic.color);
            }
        });

    }
);

export const topicApplyAsTag = defineCommand(
    'topicApplyAsTag',
    'Topic: Apply As Tag',
    (cc, [targetId]: [string?]) => {

        const index = cc.resolve(TopicIndex);
        const topic = resolveSubject(cc, targetId)?.as(Topic);

        if (!topic) return;
        const items = index.lookup(topic.id);
        if (items.size === 0) return;

        cc.dispatch(tagsAdd, [topic.label, topic.label, '', topic.color, Array.from(items).map(i => i.id)]);

    }
);

export const topicCreate = defineCommand(
    'topicCreate',
    'Topic: Create',
    (cc, [targetIds]: [string[]?]) => {

        const objects = cc.resolve(ObjectManager);
        const index = cc.resolve(TopicIndex);

        const subjects = Phys.from(resolveSubjects(cc, targetIds))
            .polarize(Sticky);

        if (!subjects.size) return;

        // const topic = new Topic(label);
        // cc.dispatch(topic);

        const bounds = subjects.bounds();

        objects.update(u => {

            const root = objects.getRoot();

            const topic = u.create(Topic);
            topic.label = '';
            topic.color = Arr.random(ContrastColorList);

            const size = topic.getPreferredSize();
            topic.width = size.w;
            topic.height = size.h;
            topic.moveTo(bounds.center().subtract(size.divide(2)));

            root.add(topic);

            for (const s of subjects) {
                TopicAssocation.set(s, topic.id);
                index.invalidate(s);
            }

            cc.dispatch(topicTidy, [topic.id]);
            cc.dispatch(beginMutating, [topic.id, true]);
        });

    }
);

export const inTopicCommands = () => inCommands(
    topicTidy,
    topicApplyColor,
    topicApplyAsTag,
    topicCreate,
);
